import { render, staticRenderFns } from "./SaberDelProducto.vue?vue&type=template&id=deb74658&scoped=true&"
import script from "./SaberDelProducto.vue?vue&type=script&lang=js&"
export * from "./SaberDelProducto.vue?vue&type=script&lang=js&"
import style0 from "./SaberDelProducto.vue?vue&type=style&index=0&id=deb74658&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb74658",
  null
  
)

export default component.exports